import React from 'react'
import arrowLeft from '../../../../../img/arrowLeft.png'
import arrowRight from '../../../../../img/arrowRight.png'
import { Video } from '../Video/Video'
import styles from './SubscribersList.module.scss'

export const SubscribersList = ({ users }) => {
  return (
    <div className={styles.container}>
      {users.length !== 0 && <img src={arrowLeft} alt='o_O' />}
      <div className={styles.subscribers}>
        {users.map((user, i) => (
          <div key={i} className={styles.streamContainer}>
            <Video streamManager={user} subscribers={true}/>
          </div>
        ))}
      </div>
      {users.length !== 0 && <img src={arrowRight} alt='o_O' />}
    </div>
  )
}
